import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "FANN - neural networks made easy",
  "description": "",
  "published": "2012-02-20T00:00:00.000Z",
  "redirect_from": ["/blog/fann-neural-networks-made-easy/swizec/3714"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/Selection_053-300x174.png",
        "alt": "Convergence!",
        "title": "Convergence!"
      }}></img></p>
    <p>{`Over the weekend I was struck with the realization that I don't know `}{`_`}{`how to use `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Neural_network",
        "title": "Neural network"
      }}>{`neural networks`}</a>{` in practice, damn it. `}{`_`}{`Even though a few months ago `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-think-i-finally-understand-what-a-neural-network-is/swizec/2891",
        "title": "I think I finally understand what a neural network is"
      }}>{`I realized what neural networks are`}</a>{`, even though I've `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-suck-at-implementing-neural-networks-in-octave/swizec/2929",
        "title": "I suck at implementing neural networks in octave"
      }}>{`tried implementing them`}</a>{`, even though I've used them in a class setting ...`}</p>
    <p>{`How the hell do you use these things in real life!?`}</p>
    <p>{`Implement from scratch? ... no that can't be it.`}</p>
    <p>{`Find a library, write some code, run some tests, fiddle with features, run a test, fiddle with features, realize everything is slow, decide to use more layers, fiddle with features, play around with activation functions, run a test, fiddle with features, rewrite the code because it's a mess, fiddle with features, run a test, run the network, run more tests and so on and on `}<em parentName="p">{`ad nauseum`}</em>{`.`}</p>
    <p>{`That can't be it either ...`}</p>
    <h2 {...{
      "id": "fann"
    }}>{`FANN`}</h2>
    <p>{`Looking far and wide for a good library to use I stumbled upon `}<a parentName="p" {...{
        "href": "http://leenissen.dk/fann/wp/"
      }}>{`FANN - Fast Artificial Neural Networks`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Fast Artificial Neural Network Library is a free open source neural network library, which implements multilayer artificial neural networks in C with support for both fully connected and sparsely connected networks. Cross-platform execution in both fixed and floating point are supported. It includes a framework for easy handling of `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Training_set",
          "title": "Training set"
        }}>{`training data`}</a>{` sets. It is easy to use, versatile, well documented, and fast. Bindings to more than `}<a parentName="p" {...{
          "href": "http://leenissen.dk/fann/wp/language-bindings/"
        }}>{`15 programming languages`}</a>{` are available. An easy to read introduction `}<a parentName="p" {...{
          "href": "http://fann.sf.net/fann_en.pdf"
        }}>{`article`}</a>{` and a `}<a parentName="p" {...{
          "href": "http://leenissen.dk/fann/html/index.html"
        }}>{`reference manual`}</a>{` accompanies the library with examples and recommendations on how to use the library. Several graphical `}<a parentName="p" {...{
          "href": "http://leenissen.dk/fann/wp/graphical-interface/"
        }}>{`user interfaces`}</a>{` are also available for the library.`}</p>
    </blockquote>
    <p>{`Perfect!`}</p>
    <p>{`Not only has someone gone to the trouble of implementing everything and making sure it works - nothing sucks more than figuring out whether you're using your learning software wrong or it's just buggy - they even gave it all the fiddly features I need!`}</p>
    <p>{`It gets better! There's a slew of graphical interfaces -> You get to play with the fiddly bits without even knowing what you're doing! Yes!`}</p>
    <p>{`Put the data in the fann format, load it up, and away you go. Playing around until you figure out what you're looking for, then you can just implement the same thing with the FANN binding of your choice.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/Selection_050.png",
        "alt": "It can suggest a good training algo",
        "title": "It can suggest a good training algo"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/Selection_052.png",
        "alt": "You get to set up the neural network",
        "title": "You get to set up the neural network"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/Selection_051.png",
        "alt": "Fiddly bits!",
        "title": "Fiddly bits!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/Selection_053.png",
        "alt": "Watch it converge in real time",
        "title": "Watch it converge in real time"
      }}></img></p>
    <h2 {...{
      "id": "done-in-a-few-hours"
    }}>{`Done in a few hours`}</h2>
    <p>{`FANN really saved my skin last night. At least the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Graphical_user_interface",
        "title": "Graphical user interface"
      }}>{`GUI`}</a>{` did. I still haven't solved my problem - trying to predict how many people will read a whole post - but it took me literally a couple of minutes to realize that the same network can't be used to predict two outputs since it won't even converge.`}</p>
    <p>{`That's something very specific to the problem.`}</p>
    <p>{`I also realized the networks were overfitting my data, then performing poorly on the test.`}</p>
    <p>{`Another specific thing.`}</p>
    <p>{`It is because of this incredibly problem-specific nature of most work involving neural networks that having tools like these is really important. Who wants to fiddle around with implementing all this stuff by hand for several hours before even running the first tests?`}</p>
    <p>{`I probably ran twenty or thirty different configurations in the space of three hours last night. Could I have done that without a simple tool? Probably not - wouldn't even have the first configuration implemented by now.`}</p>
    <p>{`Now if only the GUI tool calculated precision and recall instead of mean standard error ...`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-think-i-finally-understand-what-a-neural-network-is/swizec/2891"
        }}>{`I think I finally understand what a neural network is`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-suck-at-implementing-neural-networks-in-octave/swizec/2929"
        }}>{`I suck at implementing neural networks in octave`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://horicky.blogspot.com/2012/02/characteristics-of-machine-learning.html"
        }}>{`Characteristics of Machine Learning Model`}</a>{` (horicky.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8595741/neural-network-should-the-algorithm-be-rewritten-for-every-case"
        }}>{`Neural network: should the algorithm be rewritten for every case?`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8697054/is-it-possible-for-encog-or-neuroph-to-run-on-android"
        }}>{`Is it possible for Encog or Neuroph to run on Android?`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/sabbatical-week-day-3-raining-datatypes/swizec/3293"
        }}>{`Sabbatical week day 3: Raining datatypes`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8682766/c-machine-learning-framework"
        }}>{`C++ machine learning framework`}</a>{` (stackoverflow.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3b9f04bc-86a6-49e2-b0f1-6044eb94681d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      